import dashboardSources from './dashboard-source.route'
import registrationSignature from './registration-signature.route'
import centrallevelcomplaintsstatusRoute from './centrallevelcomplaintsstatus.route'
import refundstatusRoute from './refundstatus.route'
import rpproviderbilingstatusindicatorRoute from './rpproviderbilingstatusindicator.route'

const routes = [
  {
    path: '/dashboard',
    component: () => import('@/views/dashboard/DashboardWrapper.vue'),
    children: [
      {
        path: '/',
        name: 'dashboard',
        component: () => import('@/views/dashboard/Menu.vue'),
      },
      dashboardSources,
      centrallevelcomplaintsstatusRoute,
      refundstatusRoute,
      registrationSignature,
      rpproviderbilingstatusindicatorRoute,
    ],
  },
]

export default routes
